<template>
    <div class="report-page rfm-report">
        <div class="container-fluid pt-3">
            <h2>{{ t("rfm_report-page_title") }}</h2>
            <div class="rfm-grid box">
                <div class="main-grid">
                <div @click="activeGroup = 'cant_lose'" class="cant_lose">
                    <span
                        >{{ t("rfm_groups-cant_lose") }} <br />
                        <strong>{{ history.cant_lose }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'champion'" class="champion">
                    <span
                        >{{ t("rfm_groups-champion") }} <br />
                        <strong>{{ history.champion }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'loyal'" class="loyal">
                    <span
                        >{{ t("rfm_groups-loyal") }} <br />
                        <strong>{{ history.loyal }}</strong>
                    </span>
                </div>
                <div
                    @click="activeGroup = 'needs_attention'"
                    class="needs_attention"
                >
                    <span
                        >{{ t("rfm_groups-needs_attention") }}
                        <br />
                        <strong>{{ history.needs_attention }}</strong>
                    </span>
                </div>
                <div
                    @click="activeGroup = 'potential_champion'"
                    class="potential_champion"
                >
                    <span
                        >{{ t("rfm_groups-potential_champion") }}
                        <br />
                        <strong>{{ history.potential_champion }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'new'" class="new">
                    <span
                        >{{ t("rfm_groups-new") }} <br />
                        <strong>{{ history.new }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'promising'" class="promising">
                    <span
                        >{{ t("rfm_groups-promising") }} <br />
                        <strong>{{ history.promising }}</strong>
                    </span>
                </div>
                <div
                    @click="activeGroup = 'about_to_sleep'"
                    class="about_to_sleep"
                >
                    <span
                        >{{ t("rfm_groups-about_to_sleep") }}
                        <br />
                        <strong>{{ history.about_to_sleep }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'at_risk'" class="at_risk">
                    <span
                        >{{ t("rfm_groups-at_risk") }} <br />
                        <strong>{{ history.at_risk }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'hibernating'" class="hibernating">
                    <span
                        >{{ t("rfm_groups-hibernating") }} <br />
                        <strong>{{ history.hibernating }}</strong>
                    </span>
                </div>
                <div @click="activeGroup = 'lost'" class="lost">
                    <span
                        >{{ t("rfm_groups-lost") }} <br />
                        <strong>{{ history.lost }}</strong>
                    </span>
                </div>

                <div class="legend legend-left">
                    <div class="title">
                        <strong>
                            {{ t("rfm_report-legend_frequency_monetary") }}
                        </strong>
                    </div>
                    <div class="grade">5</div>
                    <div class="grade">4</div>
                    <div class="grade">3</div>
                    <div class="grade">2</div>
                    <div class="grade">1</div>
                </div>
                <div class="legend legend-bottom">
                    <div class="grade">1</div>
                    <div class="grade">2</div>
                    <div class="grade">3</div>
                    <div class="grade">4</div>
                    <div class="grade">5</div>
                    <div class="title"><strong>{{ t("rfm_report-recency") }}</strong></div>
                </div>
            </div>
        </div>
        <div class="box clients-list" v-if="activeGroup">
            <grid
                :source="'clients/rfm-report/list?group=' + activeGroup"
                :filters="{}"
                :show-search="false"
            >
                <template v-slot:grid-header="response">
                    <div>
                        <h3>
                            {{ t("rfm_groups-" + activeGroup) }}
                        </h3>
                        <div class="row stats">
                            <div class="col-sm-12 col-md-4">
                                <div class="box">
                                    <div class="icon">
                                        <Icon icon-class="ui-calendar" size="13" />
                                    </div>
                                    <div class="info">
                                        <div class="number">
                                            <human-date
                                                format="[d]/[M]/[Y]"
                                                :date="
                                                    response.data.stats
                                                        .min_recency
                                                "
                                            />
                                            -
                                            <human-date
                                                format="[d]/[M]/[Y]"
                                                :date="
                                                    response.data.stats
                                                        .max_recency
                                                "
                                            />
                                        </div>
                                        <div class="label">{{ t("rfm_report-last_purchase") }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <div class="box">
                                    <div class="icon">
                                        <Icon icon-class="ui-shopping-cart-03" size="13" />
                                    </div>
                                    <div class="info">
                                        <div class="number">
                                            {{
                                                response.data.stats
                                                    .min_frequency
                                            }}
                                            {{ t("rfm_report-range_to") }}
                                            {{
                                                response.data.stats
                                                    .max_frequency
                                            }}
                                            {{ t("rfm_report-purchases") }}
                                        </div>
                                        <div class="label">
                                            {{ t("rfm_report-made_in_last") }}
                                            {{ response.data.stats.rfm_period }}
                                            {{ t("rfm_report-days") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <div class="box">
                                    <div class="icon">
                                        <Icon icon-class="ui-bank-note-01" size="13" />
                                    </div>
                                    <div class="info">
                                        <div class="number">
                                            {{ currencySymbol }}{{
                                                round(
                                                    response.data.stats
                                                        .min_monetary,
                                                )
                                            }}
                                            {{ t("rfm_report-range_to") }} {{ currencySymbol }}{{
                                                round(
                                                    response.data.stats
                                                        .max_monetary,
                                                )
                                            }}
                                        </div>
                                        <div class="label">
                                            {{ t("rfm_report-spent_in_last") }}
                                            {{ response.data.stats.rfm_period }}
                                            {{ t("rfm_report-days") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-slot:rows="grid">
                    <thead>
                        <tr>
                            <grid-th
                                :grid="grid"
                                :sortable="false"
                                attr="client_name"
                                >{{ t("rfm_report-client") }}</grid-th
                            >
                            <grid-th
                                :grid="grid"
                                :sortable="false"
                                attr="whatsapp"
                                >{{ t("rfm_report-phone") }}</grid-th
                            >
                            <grid-th :grid="grid" :sortable="false" attr="email"
                                >{{ t("rfm_report-email") }}</grid-th
                            >
                            <grid-th
                                :grid="grid"
                                :sortable="false"
                                attr="rfm_score_r"
                                >{{ t("rfm_report-recency") }}</grid-th
                            >
                            <grid-th
                                :grid="grid"
                                :sortable="false"
                                attr="rfm_score_f"
                                >{{ t("rfm_report-frequency") }}</grid-th
                            >
                            <grid-th
                                :grid="grid"
                                :sortable="false"
                                attr="rfm_score_m"
                                >{{ t("rfm_report-monetary") }}</grid-th
                            >
                            <grid-th
                                :grid="grid"
                                :sortable="false"
                                attr="rfm_score"
                                >{{ t("rfm_report-score") }}</grid-th
                            >
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="client in grid.data"
                            :key="client.id"
                            @click="$router.push('client/' + client.clients_id)"
                        >
                            <td>
                                {{ client.first_name }} {{ client_last_name }}
                            </td>
                            <td>{{ client.whatsapp }}</td>
                            <td>{{ client.email }}</td>
                            <td>{{ client.rfm_score_r }}</td>
                            <td>{{ client.rfm_score_f }}</td>
                            <td>{{ client.rfm_score_m }}</td>
                            <td>{{ client.rfm_score }}</td>
                        </tr>
                    </tbody>
                </template>
            </grid>
        </div>
    </div>
    </div>
</template>
<style lang="scss" scoped>
.clients-list {
    h3 {
        margin-bottom: 20px;
    }
}
.stats .info .number {
    font-size: 18px;
}

.stats {
    margin-bottom: -20px;
}

.rfm-grid {
    display: block;
    padding-bottom: 100px;
    padding-left: 100px;
    position: relative;
    margin-top: 0px;
    .main-grid {
        width: 100%;
        max-width: 500px;
        height: auto;
        aspect-ratio: 1/1;
        position: relative;
        display: grid;
        grid-gap: 0;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
        color: #fff;
        .legend {
            z-index: 2;
            color: #333;
        }
        strong {
            font-weight: 600;
        }
        > :not(.legend) {
            border: 1px solid #000;
            padding: 10px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            transition: all 0.3s;
            z-index: 3;
            box-shadow: inset 0 0 5px transparent;
            &:hover {
                cursor: pointer;
                box-shadow: inset 0 0 10px #fff;
            }
        }

        .cant_lose {
            grid-column: 1 / 3;
            grid-row: 1 / 2;
            background: #fdb000;
        }

        .at_risk {
            grid-column: 1 / 3;
            grid-row: 2 / 4;
            background: #fd5900;
        }

        .lost {
            grid-column: 1 / 3;
            grid-row: 4 / 6;
            background: #601;
            padding-top: 50%;
            padding-right: 50%;
        }

        .hibernating {
            grid-column: 2 / 3;
            grid-row: 4 / 5;
            background: #b02034;
            z-index: 4;
        }

        .loyal {
            grid-column: 3 / 6;
            grid-row: 1 / 3;
            background: #74d6a3;
            padding-top: 33%;
            padding-right: 33%;
        }

        .champion {
            grid-column: 5 / 6;
            grid-row: 1 / 2;
            background: var(--primary);
            z-index: 4;
        }

        .needs_attention {
            grid-column: 3/4;
            grid-row: 3/4;
            background: #15c2ec;
        }

        .new {
            grid-column: 5/6;
            grid-row: 5/6;
            background: #5f6781;
        }

        .promising {
            grid-column: 4/5;
            grid-row: 5/6;
            background: #8a5594;
        }

        .potential_champion {
            grid-column: 4/6;
            grid-row: 3 / 5;
            background: #17304c;
        }

        .about_to_sleep {
            grid-column: 3/4;
            grid-row: 4 / 6;
            background: #d99c1b;
        }
    }

    .legend-left {
        position: absolute;
        left: -100px;
        top: 0;
        height: 100%;
        width: 100px;
        display: grid !important;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
        padding: 0 !important;
        > div {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            &:not(.title) {
                border-top: 1px solid #000;
            }
            &:last-child {
                border-bottom: 1px solid #000;
            }
        }
        .title {
            grid-column: 1 / 2;
            grid-row: 1 / 6;
            position: relative;
            writing-mode: vertical-rl;
            strong {
                transform: rotate(180deg);
                transform-origin: 50% 50%;
            }
        }
    }

    .legend-bottom {
        position: absolute;
        left: 0;
        bottom: -100px;
        width: 100%;
        height: 100px;
        display: grid !important;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        > div {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            &:not(.title) {
                border-right: 1px solid #000;
            }
            &:first-child {
                border-left: 1px solid #000;
            }
        }
        .title {
            grid-column: 1 / 6;
            grid-row: 2 / 3;
        }
    }
}
</style>
<script>
import keviApi from "../keviApi";
import Grid from "../components/grid/grid";
import HumanDate from "../components/human-date/human-date";
import Icon from "../components/icon/icon";

export default {
    components: { HumanDate, Grid, Icon },
    data() {
        return {
            state: "loading",
            history: {
                cant_lose: null,
                champion: null,
                loyal: null,
                needs_attention: null,
                potential_champion: null,
                new: null,
                promising: null,
                about_to_sleep: null,
                at_risk: null,
                hibernating: null,
                lost: null,
            },
            activeGroup: null,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        t(key, ...args) {
            return this.$root.t(key, ...args);
        },
        round(x) {
            return Math.round(x);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        getData() {
            this.setState("loading");
            var options = keviApi.getOptions("clients/rfm-report", "GET", {});
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.setState("ready");
                    for (let s in response.body.history) {
                        this.$set(this.history, s, response.body.history[s]);
                    }
                }
            });
        },
        loadGroup() {
            this.setState("loading");
            var options = keviApi.getOptions("clients/rfm-report/list", "GET", {
                group: this.activeGroup,
            });
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.setState("ready");
                    for (let s in response.body.history) {
                        this.$set(this.history, s, response.body.history[s]);
                    }
                }
            });
        },
    },
    watch: {
        activeGroup() {
            this.loadGroup();
        },
    },
};
</script>
